import { useEffect } from "react";
import { scrollToError } from "../utils/scrollUtils";
export var useScrollToError = function (errors) {
    useEffect(function () {
        if (Object.keys(errors).length > 0) {
            scrollToError(errors);
        }
    }, [errors]);
};
